import React from 'react';
import PropTypes from 'prop-types';

function MaxReportsBanner(props) {
  const { reportCount } = props;
  const {
    reportLimit,
    hasAdminPrivileges,
  } = props;

  const isUnlimited = Number(reportLimit) === 1000000;

  return (
    <div className="row">
      <div className="col text-danger text-muted small">
        {reportCount}
        {' '}
        reports
        {isUnlimited ? '' : (
          <>
            {' '}
            (of
            {' '}
            {reportLimit}
            {' '}
            allowed)
          </>
        )}
        {' '}
        {reportCount >= reportLimit && (
          <span>
            <a href="/s/subscription/billing/change-plan" className="badge badge-danger">Limit Reached.</a>
            {hasAdminPrivileges && (
              <>
                &nbsp;
                <a href="/s/subscription/billing/change-plan"><u>Upgrade</u></a>
              </>
            )}
          </span>
        )}
      </div>
    </div>
  );
}
MaxReportsBanner.defaultProps = {
  hasAdminPrivileges: true,
};

MaxReportsBanner.propTypes = {
  reportCount: PropTypes.number.isRequired,
  reportLimit: PropTypes.number.isRequired,
  hasAdminPrivileges: PropTypes.bool,
};

export default MaxReportsBanner;
